import React, { useState } from "react";
import QRCode from "react-qr-code";

// 把这里换成你实际的云函数地址
// 例：https://us-central1-你的项目ID.cloudfunctions.net/storeCreateMember
var FUNCTION_URL =
  "https://us-central1-YOUR_PROJECT_ID.cloudfunctions.net/storeCreateMember";

function StoreCreateMember() {
  var [name, setName] = useState("");
  var [phone, setPhone] = useState("");
  var [membershipType, setMembershipType] = useState("monthly"); // monthly / yearly
  var [paymentMethod, setPaymentMethod] = useState("cash"); // cash / debit / credit
  var [loading, setLoading] = useState(false);
  var [error, setError] = useState("");
  var [result, setResult] = useState(null); // { memberId, expiresAt }

  // 固定第一家门店编号 = 1 => 会员号里就是 ST1
  var storeCode = "1";

  function handleSubmit(e) {
    e.preventDefault();

    setError("");
    setResult(null);

    if (!name) {
      setError("请填写会员姓名");
      return;
    }

    setLoading(true);

    var body = {
      name: name,
      phone: phone,
      membershipType: membershipType,
      paymentMethod: paymentMethod,
      storeCode: storeCode,
    };

    fetch('https://us-central1-riceroma202606.cloudfunctions.net/storeCreateMember', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.ok) {
          setResult({
            memberId: data.memberId,
            expiresAt: data.expiresAt,
          });
        } else {
          if (data && data.error) {
            setError("开卡失败：" + data.error);
          } else {
            setError("开卡失败：未知错误");
          }
        }
      })
      .catch(function (err) {
        console.error(err);
        setError("网络或服务器错误");
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function renderBenefits() {
    if (membershipType === "monthly") {
      return (
        <ul style={{ marginTop: 8, paddingLeft: 20, fontSize: 14 }}>
          <li>每位月会员赠送 <strong>一份免费午餐</strong>（试营业活动可调）</li>
          <li>月会员在有效期内享受 <strong>会员价</strong></li>
          <li>可参加 <strong>会员专享促销/活动</strong></li>
        </ul>
      );
    }

    return (
      <ul style={{ marginTop: 8, paddingLeft: 20, fontSize: 14 }}>
        <li>每位年会员 <strong>每月一份免费午餐</strong></li>
        <li>年会员在有效期内享受 <strong>会员价</strong></li>
        <li>可参加 <strong>会员专享促销/活动</strong></li>
        <li>
          年会员价格折上折：原价 9.95 × 12 ≈ 119.4，
          <strong>年卡仅 99 元</strong>
        </li>
      </ul>
    );
  }

  // … 在 StoreCreateMember 组件函数体里，靠近 return 上面
  let qrValue = '';
  if (result && result.memberId) {
  qrValue = 'https://riceroma.ca/verify?mid=' + result.memberId;
  }

  return (
    <div
      style={{
        maxWidth: 720,
        margin: "24px auto",
        padding: "16px",
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >
      <h2 style={{ marginBottom: 16 }}>门店现场办理会员</h2>

      <p style={{ fontSize: 14, color: "#666" }}>
        门店：Riceroma 5418 Yonge St.（门店编号 ST1）
      </p>

      <form
        onSubmit={handleSubmit}
        style={{
          marginTop: 16,
          padding: 16,
          borderRadius: 12,
          border: "1px solid #eee",
          backgroundColor: "#fafafa",
        }}
      >
        {/* 姓名 */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: "block", marginBottom: 4 }}>会员姓名 *</label>
          <input
            type="text"
            value={name}
            onChange={function (e) {
              setName(e.target.value);
            }}
            style={{
              width: "100%",
              padding: "8px 10px",
              borderRadius: 6,
              border: "1px solid #ddd",
            }}
            placeholder="请输入会员姓名"
          />
        </div>

        {/* 电话（选填） */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: "block", marginBottom: 4 }}>
            联系电话（选填）
          </label>
          <input
            type="text"
            value={phone}
            onChange={function (e) {
              setPhone(e.target.value);
            }}
            style={{
              width: "100%",
              padding: "8px 10px",
              borderRadius: 6,
              border: "1px solid #ddd",
            }}
            placeholder="便于联系与售后"
          />
        </div>

        {/* 会员类型 */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: "block", marginBottom: 4 }}>会员类型 *</label>
          <label style={{ marginRight: 16 }}>
            <input
              type="radio"
              value="monthly"
              checked={membershipType === "monthly"}
              onChange={function () {
                setMembershipType("monthly");
              }}
            />{" "}
            月卡会员
          </label>
          <label>
            <input
              type="radio"
              value="yearly"
              checked={membershipType === "yearly"}
              onChange={function () {
                setMembershipType("yearly");
              }}
            />{" "}
            年卡会员
          </label>

          {/* 权益说明 */}
          <div
            style={{
              marginTop: 8,
              padding: 8,
              backgroundColor: "#fff7eb",
              borderRadius: 8,
              border: "1px solid #ffe2b8",
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#d76b00",
                marginBottom: 4,
              }}
            >
              当前选择：{membershipType === "monthly" ? "月卡会员权益" : "年卡会员权益"}
            </div>
            {renderBenefits()}
          </div>
        </div>

        {/* 付款方式 */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: "block", marginBottom: 4 }}>付款方式 *</label>
          <select
            value={paymentMethod}
            onChange={function (e) {
              setPaymentMethod(e.target.value);
            }}
            style={{
              width: "100%",
              padding: "8px 10px",
              borderRadius: 6,
              border: "1px solid #ddd",
            }}
          >
            <option value="cash">现金</option>
            <option value="debit">借记卡 / Debit</option>
            <option value="credit">信用卡 / Credit</option>
            <option value="other">其他</option>
          </select>
        </div>

        {/* 提交按钮 */}
        <button
          type="submit"
          disabled={loading}
          style={{
            marginTop: 8,
            width: "100%",
            padding: "10px 16px",
            borderRadius: 999,
            border: "none",
            backgroundColor: "#ff7a00",
            color: "#fff",
            fontSize: 16,
            fontWeight: 600,
            cursor: loading ? "default" : "pointer",
          }}
        >
          {loading ? "正在生成会员号…" : "生成会员号"}
        </button>

        {error && (
          <div
            style={{
              marginTop: 10,
              color: "#d93025",
              fontSize: 14,
            }}
          >
            {error}
          </div>
        )}
      </form>

      {/* 结果展示 + 二维码打印区 */}
      {/* 结果展示 + 二维码打印区 */}
      {result && (
        <div
          style={{
            marginTop: 24,
            maxWidth: 720,
            marginLeft: "auto",
            marginRight: "auto",
            padding: 16,
            borderRadius: 16,
            backgroundColor: "#ffffff",
            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
          }}
        >
          {/* 打印按钮：店员点一下，直接打印这一页 */}
          <button
            type="button"
            onClick={function () {
              window.print();
            }}
            style={{
              display: "inline-block",
              marginBottom: 12,
              padding: "8px 18px",
              borderRadius: 999,
              border: "none",
              backgroundColor: "#ff7a00",
              color: "#ffffff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            打印此页 / Print this card
          </button>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 16,
              alignItems: "flex-start",
            }}
          >
            {/* 左边：二维码 */}
            <div style={{ flex: "0 0 180px", textAlign: "center" }}>
              <QRCode
                value={qrValue}
                size={160}
                style={{ width: "100%", height: "auto" }}
              />
              <div
                style={{
                  fontSize: 12,
                  marginTop: 6,
                  color: "#666",
                  lineHeight: 1.4,
                }}
              >
                向店员出示此二维码或会员号
                <br />
                Show this QR code or Member ID
              </div>
            </div>

            {/* 右边：会员卡信息（给客人拍照/打印） */}
            <div
              style={{
                flex: "1 1 220px",
                fontSize: 14,
                lineHeight: 1.7,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 8,
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    color: "#ff7a00",
                  }}
                >
                  饭美丽 Riceroma
                </div>
                <div
                  style={{
                    fontSize: 11,
                    padding: "3px 8px",
                    borderRadius: 999,
                    backgroundColor: "#fff4e6",
                    color: "#cc6a00",
                  }}
                >
                  现场会员 / In-store Member
                </div>
              </div>

              <p style={{ margin: "4px 0" }}>
                <strong>会员编号 / Member ID：</strong>
                {result.memberId}
              </p>
              <p style={{ margin: "4px 0" }}>
                <strong>会员类型 / Type：</strong>
                {membershipType === "monthly"
                  ? "月卡会员 / Monthly"
                  : "年卡会员 / Yearly"}
              </p>
              <p style={{ margin: "4px 0" }}>
                <strong>办理门店 / Store：</strong>
                Riceroma 5418 Yonge St.（ST1）
              </p>
              <p style={{ margin: "4px 0" }}>
                <strong>有效期至 / Valid until：</strong>
                {result.expiresAt}
              </p>
              <p style={{ margin: "4px 0" }}>
                <strong>付款方式 / Payment：</strong>
                {paymentMethod === "debit"
                  ? "借记卡 / Debit"
                  : paymentMethod === "credit"
                  ? "信用卡 / Credit"
                  : paymentMethod === "other"
                  ? "其他 / Other"
                  : "现金 / Cash"}
              </p>

              <p style={{ margin: "10px 0 4px" }}>
                <strong>会员权益 / Benefits：</strong>
              </p>
              {renderBenefits()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default StoreCreateMember;